// extracted by mini-css-extract-plugin
export default {"wrapper":"QuestionList_wrapper__jjWUo"};